import { useFirebaseConfig } from "./remote-config";

export default function useRtkq() {
  const firebaseConfig = useFirebaseConfig()
  
  return firebaseConfig.config.useRtkq?.asBoolean() ?? true
}